@if (isLoading) {
    <div class="fancy-loader submodule my-4"></div>
} @else {
    @if (config) {
        <generic-list-manager [config]="config" [skipReloadConfirm]="true"></generic-list-manager>
    }
}
